<template>
  <MainStructure>
    <div class="content-list-exercise d-flex flex-column align-items-center pb-5">

      <div class="tille mt-3 w-80 d-flex flex-column text-start">
        <h4 class="fw-bold mb-2">{{ labStore.currentLab?.title || 'Laboratório de Práticas' }}</h4>
        <p class="text-muted">{{ labStore.currentLab?.description || 'Acesse os níveis abaixo para exercitar práticas.' }}</p>
      </div>

      <div v-if="state.loading" class="spinner-border text-primary mt-5">
        <span class="visually-hidden">Loading...</span>
      </div>

      <div
          v-else
          class="w-100 d-flex flex-column align-items-center"
          v-for="(groupData, groupName, groupIndex) in store.getGroupedExercises()"
          :key="groupName"
      >
        <div class="w-80 mt-4 mb-3" :data-tour="groupName === 'Tutorial' ? 'tutorial-section' : undefined">
          <h5 class="align-self-start text-muted m-0 fw-semibold">{{ groupName }}</h5>
        </div>

        <div class="cards d-flex justify-content-start flex-wrap gap-4 w-80">
          <p v-if="state.withoutExercises" class="font-size-error text-danger">Sem exercícios para exibir</p>
          <CardExercise
              v-else
              v-for="(exercise, exIndex) in groupData.exercises"
              :key="exercise.id"
              :exercise="exercise"
              :is-first="groupIndex === 0 && exIndex === 0"
          />
        </div>
      </div>

      <div v-if="!state.loading && Object.keys(store.getGroupedExercises()).length === 0 && !state.withoutExercises" class="w-80 mt-4">
        <p class="text-muted">Nenhum exercício encontrado para este laboratório.</p>
      </div>

    </div>
  </MainStructure>
</template>

<script setup>
import MainStructure from '@/components/layoutParts/MainStructure.vue';
import CardExercise from '@/components/layoutParts/CardExercise.vue';
import { inject, onMounted, reactive, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import { useTour } from '@/composables/useTour';

import { useExerciseStore } from '@/stores/exercise';
import { useLaboratoryStore } from '@/stores/laboratoryStore';

const state = reactive({
  withoutExercises: false,
  loading: false
});

const axios = inject('axios');
const store = useExerciseStore();
const labStore = useLaboratoryStore();
const route = useRoute();
const { startTour, registerTourListener } = useTour();

const TOUR_NAME = 'listExercises';

function getTourSteps() {
  return [
    { element: '[data-tour="tutorial-section"]', popover: { title: 'Tutorial', description: 'Comece pelo tutorial para entender como usar o simulador.' } },
    { element: '[data-tour="exercise-card"]', popover: { title: 'Práticas', description: 'Cada prática possui um nível de dificuldade e objetivos específicos.' } },
    { element: '[data-tour="status-badge"]', popover: { title: 'Status da prática', description: 'Acompanhe seu progresso por aqui.' } },
    { element: '[data-tour="capabilities-button"]', popover: { title: 'Capacidades por Curso', description: 'Visualize as capacidades desenvolvidas em cada prática, organizadas por curso.' } },
    { element: '[data-tour="exercise-card"]', popover: { title: 'Como acessar', description: 'Clique no Botão "Acessar Prática" para iniciar ou continuar uma prática.' } }
  ];
}

registerTourListener(TOUR_NAME, getTourSteps);

onMounted(() => {
  loadExercises();
});

function loadExercises() {
  state.loading = true;
  store.exercises = []

  const labSlug = route.params.lab_slug;

  axios().get('/exercise', { params: { lab_slug: labSlug } }).then(async ({ data }) => {
    state.withoutExercises = data.length === 0;
    state.loading = false;
    store.exercises = data;
    await nextTick();
    startTour(TOUR_NAME, getTourSteps());
  }).catch(() => {
    state.loading = false;
    state.withoutExercises = true;
  })
}
</script>

<style scoped>
.w-80 {
  width: 80%;
}

.cards {
  height: 100%;
}

.content-list-exercise {
  max-width: 100%;
  min-width: 100%;
  max-height: 98%;
  min-height: 98%;
}

.hover-primary:hover {
  color: #1A5FD5 !important;
}

.transition-colors {
  transition: color 0.2s ease;
}
</style>